module.exports = __webpack_public_path__ + "static/media/montblanc-what-moves-you-makes-you-2.e2c8e77d.jpg";